module.exports = __webpack_public_path__ + "25979366faf5e84513316a345b66914d.png";